<template>
  <div class="paper-container">
    <div class="go-back" @click="$router.go(-1)" v-if="false">
      <i class="el-icon-arrow-left"></i>返回
    </div>
    <div class="paper-detail">
      <div class="paper-title">
        <span class="paper-bg">项目</span>
        <div class="paper-title-style">{{ projectData.title }}</div>
      </div>
      <div
        style="
          width: 100%;
          border-bottom: 1px dashed #e8eaee;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      ></div>
      <div style="display: flex; margin-top: 8px">
        <!-- 项目编号-->

        <div class="text-title">
          <span class="textSpan">项目编号：</span>
          <div class="textContent">
            {{ projectData.id == null ? '-' : projectData.id }}
          </div>
        </div>
        <!-- 项目类别-->
        <div class="text-title">
          <span class="textSpan">项目类别：</span>
          <div class="textContent">
            {{
              projectData.typeFirst === null
                ? projectData.typeSecondary === null
                  ? projectData.typeSecondary === null
                    ? '-'
                    : projectData.typeSecondary === null
                  : projectData.typeSecondary
                : projectData.typeFirst
            }}
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 项目负责人-->
        <div style="display: flex; width: 50%">
          <span class="textSpan">项目负责人：</span>
          <div
            style="
              display: flex;
              margin-right: 11px;
              align-items: center;
              cursor: pointer;
            "
            v-if="projectData.leaderItem"
            @click="goPersonalDetails(projectData.leaderItem.id)"
          >
            <el-avatar
              class="avatar"
              :size="18"
              :src="projectData.leaderItem.avatar"
            />
            <div style="margin-left: 6px; color: #2e1f88" class="textContent">
              {{ projectData.leaderItem.scholarName }}
            </div>
          </div>
          <div v-else>-</div>
        </div>
        <!-- 项目金额-->
        <div class="text-title">
          <span class="textSpan">项目金额（万元）：</span>
          <div class="textContent">
            {{ projectData.fund == null ? '-' : projectData.fund }}
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 所属机构 -->
        <div class="text-title">
          <span class="textSpan">所属机构：</span>
          <div class="textContent">
            {{ projectData.org == null ? '-' : projectData.org }}；
          </div>
        </div>
        <!-- 所属学部-->
        <div class="text-title">
          <span class="textSpan">所属学部：</span>
          <div class="textContent">
            {{ projectData.department == null ? '-' : projectData.department }}
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 批准年份-->
        <div class="text-title">
          <span class="textSpan">批准年份：</span>
          <div class="textContent">
            {{ projectData.startYear == null ? '' : projectData.startYear }}
            <span v-if="projectData.endYear !== null">-</span>
            {{ projectData.endYear == null ? '' : projectData.endYear }}
          </div>
        </div>
        <!-- 学科分类-->
        <div class="text-title">
          <span class="textSpan">学科分类：</span>
          <div class="textContent">
            {{
              projectData.disciplineFirst == null
                ? '-'
                : projectData.disciplineFirst
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProjectDetailApi } from '@/api/details';
export default {
  name: 'projectDetail',
  data() {
    return {
      isBack: null,
      backName: null,
      projectData: {},
    };
  },
  async created() {
    if (process.env.VUE_APP_NAME === 'guojiao') {
      document.title = '项目详情';
    }
    this.isBack = this.$route.query.isBack;
    this.backName = this.$route.query.backName;

    this.getProjectDetails();
  },
  methods: {
    goPersonalDetails(id) {
      if (id) {
        let obj = {
          name: 'talentDetail',
          query: { id },
        };
        let routeData = this.$router.resolve(obj);
        window.open(routeData.href, '_blank');
      } else {
        this.$message.warning({
          message: '暂无详情数据',
          type: 'warning',
        });
      }
    },
    getProjectDetails() {
      getProjectDetailApi(this.$route.query.id).then((res) => {
        this.projectData = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.go-back {
  color: #667085;
  font-size: 16px;
  cursor: pointer;
  width: 1190px;
  text-align: start;
  margin-bottom: 10px;
}
.paper-container {
  margin: 10px auto 0;
  width: 1200px;
  height: calc(100vh - 92px);
  //line-height: 1080px;
}
.paper-detail {
  width: 1190px;
  //min-height: 800px;
  height: fit-content;
  align-content: center;
  background: #ffffff;
  padding: 25px 30px;
  border-radius: 16px;

  .paper-title {
    display: flex;
    align-items: flex-start;

    .paper-bg {
      font-size: 16px;
      color: #f39800;
      background: rgba(243, 152, 0, 0.12);
      padding: 4px 8px;
      border-radius: 4px;
      flex-shrink: 0;
    }

    .paper-title-style {
      font-size: 20px;
      margin-left: 9px;
      font-weight: bold;
      color: #101828;
      text-align: left;
      line-height: 24px;
    }
  }

  .text-title {
    display: flex;
    width: 50%;
    text-align: start;
  }

  .textSpan {
    color: #667085;
    font-size: 16px;
    line-height: 24px;
    min-width: 80px;
  }

  .textContent {
    color: #344054;
    font-size: 16px;
    line-height: 24px;
    word-break: break-all;
    margin-right: 10px;
  }
}
</style>
